import HomeIcon from '@mui/icons-material/Home';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

export const backOfficeSideBarValues = [
  {
    title: 'Empresas',
    option: 0,
    link: '/backoffice',
    icon: <HomeIcon />,
    children: [
      {
        title: 'Ver Empresas',
        link: '/backoffice/companies',
      },
    ],
  },
  {
    title: 'Motoristas',
    option: 1,
    link: '/backoffice/drivers',
    icon: <EventAvailableIcon />,
    children: [
      {
        title: 'Motoristas',
        link: '/backoffice/drivers',
      },
    ],
  },
];
